import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { name: 'Services', path: '/services' },
  { name: 'How we work', path: '/how-we-work' },
  { name: 'Projects', path: '/projects' },
  { name: 'About', path: '/about' },
  { name: 'Contact', path: '/contact' },
];

export const Navigation = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header data-testid="main-navigation" className={`hdr${scrolled ? ' scrolled' : ''}`}>
      <div className="wrap">
        <nav aria-label="Main">
          <Link to="/" className="logo" data-testid="logo-link">
            <img src="/logo.png" alt="BuildiTech Engineering Consultants" />
          </Link>

          <div className="links">
            {navLinks.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.path.slice(1)}`}
                className={({ isActive }) => (isActive ? 'active' : undefined)}
              >
                {link.name}
              </NavLink>
            ))}
          </div>

          <Link to="/contact" className="btn btn-p btn-sm cta-desk" data-testid="nav-cta-button">
            Discuss a project <span className="ar">→</span>
          </Link>

          <button
            type="button"
            className="menu-btn"
            data-testid="mobile-menu-button"
            aria-expanded={open}
            aria-controls="mobile-menu"
            aria-label={open ? 'Close menu' : 'Open menu'}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </nav>

        <div id="mobile-menu" className="mobile" data-testid="mobile-menu" hidden={!open}>
          <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : undefined)}>
            Home
          </NavLink>
          {navLinks.map((link) => (
            <NavLink key={link.path} to={link.path} className={({ isActive }) => (isActive ? 'active' : undefined)}>
              {link.name}
            </NavLink>
          ))}
          <Link to="/contact" className="btn btn-p">
            Discuss a project <span className="ar">→</span>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Navigation;
